import { ScrollView, View } from 'react-native';
import type { ComponentType } from 'react';
import type { ScrollViewProps, ViewProps } from 'react-native';
import useMediumScreen from 'hooks/useMediumScreen';

export default function useResponsiveContainer(): ComponentType<ScrollViewProps | ViewProps> {
  const mediumScreen = useMediumScreen();
  return mediumScreen ? View : ScrollView;
}
